import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AutoSelectComponent } from '@app/shared/components/auto-select/auto-select.component';
import { LogisticsCatalogs } from './logistics.service';

export interface PickDialogData {
  title: string;
  message?: string;
  /** 'text' = captura libre (guía DHL); 'warehouse' = elegir locker / in-house. */
  mode: 'text' | 'warehouse';
  label: string;
  value?: string | null;
  /** Solo para 'warehouse': limita a los lockers de estos hospitales. */
  places?: string[] | null;
  required?: boolean;
  emptyLabel?: string;
  acceptLabel?: string;
}

/** Diálogo corto de un solo dato: texto o locker / in-house. Cierra con el valor (o undefined si se cancela). */
@Component({
  selector: 'app-logistics-pick-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, AutoSelectComponent],
  styles: [`.wrap { display: grid; gap: 8px; min-width: min(460px, 84vw); padding-top: 4px; } p { margin: 0 0 4px; color: #555; font-size: 13px; }`],
  template: `
<h2 mat-dialog-title>{{ d.title }}</h2>
<mat-dialog-content>
  <div class="wrap">
    @if (d.message) { <p [innerHTML]="d.message"></p> }
    @if (d.mode === 'text') {
      <mat-form-field appearance="outline">
        <mat-label>{{ d.label }}</mat-label>
        <input matInput [(ngModel)]="value" maxlength="60" autocomplete="off" (keydown.enter)="ok()">
      </mat-form-field>
    } @else {
      <app-auto-select [label]="d.label" [(ngModel)]="value" [options]="options" [labelFn]="cat.warehouseLabel"
        [allowEmpty]="!d.required" [emptyLabel]="d.emptyLabel ?? '—'"></app-auto-select>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="ref.close(undefined)">Cancelar</button>
  <button mat-flat-button color="primary" (click)="ok()" [disabled]="d.required && !String(value ?? '').trim()">{{ d.acceptLabel ?? 'Aceptar' }}</button>
</mat-dialog-actions>
  `,
})
export class PickDialogComponent {
  readonly d = inject<PickDialogData>(MAT_DIALOG_DATA);
  readonly ref = inject(MatDialogRef<PickDialogComponent>);
  readonly cat = inject(LogisticsCatalogs);
  readonly String = String;
  value: any = this.d.value ?? null;
  readonly options = this.cat.warehouses.filter(w => !this.d.places || this.d.places.includes(w.place));

  ok(): void {
    const v = this.d.mode === 'text' ? String(this.value ?? '').trim() : (this.value || null);
    if (this.d.required && !v) return;
    this.ref.close(v);
  }
}
